import { useRecordTypes } from '../useRecordTypes';
export var useRecordTypeLabel = function (targetID) {
    var _a, _b;
    if (targetID === void 0) { targetID = ''; }
    var _c = useRecordTypes().recordTypes, recordTypes = _c === void 0 ? [] : _c;
    return (_b = (_a = recordTypes.find(function (_a) {
        var id = _a.id;
        return id === targetID;
    })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '';
};
